import { render, staticRenderFns } from "./PurchasedCover.vue?vue&type=template&id=34c22e74&scoped=true&"
import script from "./PurchasedCover.vue?vue&type=script&lang=ts&"
export * from "./PurchasedCover.vue?vue&type=script&lang=ts&"
import style0 from "./PurchasedCover.vue?vue&type=style&index=0&id=34c22e74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c22e74",
  null
  
)

export default component.exports